export default __webpack_public_path__ + "static/media/homecast.d3679172.png";